import prodEnv from './config.prod'
import devEnv from './config.dev'

const stage = process.env.NODE_ENV || 'devlopment'
const config = (stage === 'production') ? prodEnv : devEnv
export default config
